<script setup lang="ts"></script>

<template>
  <icon name="lucide:history" />
</template>

<style scoped></style>
